import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { financialDocumentsMessages } from 'src/features/financialDocuments/utils/messages';
import FinancialDocumentsTable from 'src/features/financialDocuments/components/tables/FinancialDocumentsTable';

const FinancialDocumentsLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(financialDocumentsMessages.financialDocuments));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <FinancialDocumentsTable />;
};

export default FinancialDocumentsLayout;
